import { render, staticRenderFns } from "./MpStatusScreenPix.vue?vue&type=template&id=cffe994a&scoped=true&"
import script from "./MpStatusScreenPix.vue?vue&type=script&lang=js&"
export * from "./MpStatusScreenPix.vue?vue&type=script&lang=js&"
import style0 from "./MpStatusScreenPix.vue?vue&type=style&index=0&id=cffe994a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffe994a",
  null
  
)

export default component.exports